




import VueOptions from '@utils/VueOptions'
import AudienceCreativePreview from '@hostComponents/AudienceCreative/AudienceCreativePreview'

settings =
  name: 'AudienceCreativePreviewPage'
  components: { AudienceCreativePreview }

export default VueOptions.vue settings
